import React from 'react'
import { Route } from 'react-router-dom'
import DashboardLayout from '../Layouts/MainPage/Dashboard'
import Dashboard from '../Views/Web/Dashboard'
import CalenderIndex from '../Views/Web/Dashboard/CalenderIndex'

function DashboardRoutes() {
  return(
    <Route path="dashboard" element={<DashboardLayout />}>
        <Route index element={<Dashboard/>} />
         <Route path='calender' element={<CalenderIndex/>} />

       {/* <Route path='sales' element={<Salesindex/>} />
        <Route path='procurement' element={<ProcurmentDashboard/>} />
        <Route path='stores' element={<StoreIndex/>} />
        <Route path='maintenance' element={<MaintanaceIndex/>} /> */}

    </Route>
  )
    
  }
  
  export default DashboardRoutes